// === Current Campaign ===

export interface CurrentCampaignHeader {
	ScheduledBillets: number;
	CurrentBillets: number;
	WorkOrderName: string;
	ProductSizeName: string;
	ScheduledDate: string | null;
}

export interface CurrentCampaignStand {
	StandId: number;
	StandName: string;
	StandOrder: number;
	StandNumber: number;
	StandType: string;
	RollsetName: string | null;
	RollBottomName: string | null;
	RollTopName: string | null;
	BarrelName: string | null;
	PassName: string | null;
	PassId: number | null;
	PassPosition: number | null;
	CartridgeName: string | null;
	PassCountMax: number | null;
	PassCount: number | null;
}

export interface CurrentCampaignData {
	header: CurrentCampaignHeader | null;
	stands: CurrentCampaignStand[];
}

// === Future Campaigns ===

export type ChangeSuggestion = "K" | "C" | "N" | "P";

export interface FutureCampaignHeader {
	rn: number;
	ProductSizeId: number;
	ProductSizeName: string;
	ScheduledBillets: number;
	ScheduledDate: string | null;
	WorkOrderName: string;
	Timestamp: string | null;
	PrevProductSizeId: number | null;
}

export interface FutureCampaignStandDetail {
	rn: number;
	Order: number;
	StandId: number;
	StandName: string;
	StandOrder: number;
	PassId: number | null;
	PassName: string | null;
	Cartridge: string | null;
	PrevPassId: number | null;
	ChangeSuggestion: ChangeSuggestion;
}

export interface FutureCampaignsData {
	headers: FutureCampaignHeader[];
	standDetails: FutureCampaignStandDetail[];
}

// === Color Mapping ===

export const CHANGE_SUGGESTION_COLORS: Record<ChangeSuggestion, string> = {
	K: "transparent", // white — keep rolls, no action needed
	C: "#a5d6a7", // green — change rolls, cartridge available (ready)
	N: "#ef9a9a", // red — change rolls, cartridge NOT available (urgent)
	P: "#90caf9", // blue — keep rolls, minor pass change
};

export const CHANGE_SUGGESTION_LABELS: Record<ChangeSuggestion, string> = {
	C: "Change rolls, available cartridge",
	K: "Keep rolls",
	N: "Change rolls, not available cartridge",
	P: "Keep rolls, change pass",
};

export const CHANGE_SUGGESTION_TOOLTIPS: Record<ChangeSuggestion, string> = {
	K: "Keep rolls — same pass as current campaign, no action needed",
	P: "Keep rolls, change pass — required pass is available in the current barrel at a different groove position",
	C: "Change rolls — a cartridge with the required pass is prepared and ready",
	N: "Change rolls — no prepared cartridge available, new rolls needed",
};
